import { rmwPrismaCache } from '@/prisma/extensions/cache'
import { PrismaClient } from '@prisma/client'
import { readReplicas } from '@prisma/extension-read-replicas'

export async function extendsDb(prisma: PrismaClient) {
  return prisma
    .$extends(
      readReplicas({
        url: process.env.DATABASE_READ_REPLICA_URL!,
      })
    )
    .$extends({
      name: 'commonPrismaClient',
      result: {
        user: {
          password: {
            compute: () => '***',
          },
        },
      },
    })
    .$extends(rmwPrismaCache())
}
